export default __webpack_public_path__ + "static/media/chat-bubble-icon.09c2ff2f.svg";